import ProcessContainer from "./ProcessContainer";
import ProcessStore from "./ProcessStore";

export default ProcessStore(ProcessContainer);